<template>
  <div class="container_history">
    <!-- header -->
    <b-container v-if="($mq === 'mobile' || $mq === 'tablet')">
      <HeaderBackMobile :backToHome="false" leftAction="menu"/>
    </b-container>
    <b-container fluid v-else style="background-color:#F5F6F7;">
      <b-row>
        <StoreHeader />
      </b-row>
    </b-container>
    <!-- content -->
    <b-container fluid style="max-width:1336px;min-height:400px;">
      <!-- not going -->
      <template v-if="!loading && !transactions.length">
        <b-row class="mt-5" style="min-height:200px;">
          <b-col class="text-center">
            <p><font-awesome-icon style="font-size:32px;margin-right:15px;color:#525962;" :icon="['fal', 'shopping-cart']"/></p>
            <p>Não existem pedidos :(</p>
          </b-col>
        </b-row>
      </template>
      <!-- loading -->
      <template v-else-if="loading">
        <b-row >
          <InnerLoading/>
        </b-row>
      </template>
      <!-- transactions and club -->
      <template v-else>
        <!-- club -->
        <template v-if="$store.state.company.hasMembership && $store.state.company.hasMembership === true && log.points">
          <b-row style="border-bottom: 1px solid #EFEFF1;">
            <b-col cols="12" class="mt-3 mb-3 transactions_title">
              Saldo de Pontos
            </b-col>
          </b-row>
          <b-row class="mb-3" style="margin-top:20px;">
            <b-col>
              <div @click="$router.push({path:'/membership_prizes'})" class="myPointsCard2">
                <b-row>
                  <b-col style="margin:16px 24px;
                  font-style: normal;
                  font-weight: normal;
                  line-height: 20px;
                  font-size: 14px;
                  text-align: center;
                  letter-spacing: 0.25px;
                  color: #070A0F;
                  ">
                    Você tem  <span style="font-weight:500" :style="{color: getCssColor('primary_bt')}">{{log.points.available_points}} pontos</span> e precisa<br/> de <span style="font-weight:500" :style="{color: getCssColor('primary_bt')}">{{log.level_info.points_to_next_level}} </span> para mudar de nível 😀
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <!-- circle chart -->
                    <div style="margin:0 auto; width:136px; height:136px;position:relative;">
                      <div style="width:136px; height:136px; border-radius:68px;position:absolute;opacity:0.4;" :style="{backgroundColor: getCssColor('primary_bt')}">
                      </div>
                      <div style="position:absolute; top:16px; left:16px; width:104px; height:104px; border-radius:52px; background-color:#ffffff;box-shadow: 0px 4px 20px rgba(255, 102, 56, 0.35);">
                          <svg height="104" width="104">
                            <path :d="describeArc(52, 52, 52, 0, calcRadiusMax(log.points.total_points  / log.level_info.next_level.points_needed ) * 359.9999 )"
                            :fill="getCssColor('primary_bt')"
                            />
                            <circle cx="52" cy="52" r="48"  fill="#ffffff"/>
                          </svg>
                      </div>
                      <div :style="{color: getCssColor('primary_bt')}" style="
                        width:104px;
                        height:60px;
                        position:absolute;
                        top:52px;
                        left:16px;
                        text-align:center;
                        font-weight: bold;
                        font-size:22px;">
                        {{log.level_info.current_level.label}}
                      </div>
                    </div>
                    <!-- -->
                  </b-col>
                </b-row>
                <b-row>
                  <b-col style="margin:8px 24px;
                  font-style: normal;
                  font-weight: normal;
                  line-height: 16px;
                  font-size: 12px;
                  text-align: center;
                  letter-spacing: 0.4px;
                  color: #9FA2A6;
                  ">
                    Até o momento já foram  <br/>obtidos <span style="font-weight:500" :style="{color: getCssColor('primary_bt')}">{{log.points.total_points}} pontos
                    </span>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="mt-2 mb-3 text-center"><span style="font-size:16px;font-weight:500;" :style="{color: getCssColor('primary_bt')}">CLIQUE AQUI e Confira os prêmios!!!</span></b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </template>
        <!-- transactions -->
        <b-row style="border-bottom: 1px solid #EFEFF1;">
          <b-col cols="12" class="mt-3 mb-3 transactions_title">
            Histórico de Compras
          </b-col>
        </b-row>
        <b-row class="mt-3 mb-3 justify-content-center " >
          <b-col cols="11" v-for="(t, idx) in transactions" v-bind:key="idx" style="border-bottom: 1px solid #EFEFF1;">
            <b-row @click="openDetails(t)" class="mt-2 mb-2 align-items-center no-gutters">
              <b-col cols="3"><div :style="{backgroundColor:transactionStatusToColor(t.Status)}" class="status_box">{{transactionStatusToString(t.Status)}}</div></b-col>
              <b-col cols="5">
                <p style="margin:0px;" class="company_title" v-if="t.company_name">{{t.company_name}}</p>
                <p style="margin:0px;" class="history_price">{{formatDateTime(t.StatusHistory[0].statusDate)}}</p>
              </b-col>
              <b-col cols="3" class="text-right history_price "><div>R$ {{formatPrice(t.PurchaseValue)}}</div></b-col>
              <b-col cols="1" class="text-right" ><font-awesome-icon style="font-size:16px;" :icon="['fal', 'chevron-right']" :style="{color:getCssColor('primary_bt')}"/></b-col>
            </b-row>
          </b-col>
        </b-row>
      </template>

      <!-- modal detail -->
      <OpaSlideModal 
        title="Detalhes do Pedido" 
        direction="right"
        v-model="detailModal"
        @slideModalClose="() => detailModal = false"
        >
        <b-row v-if="tempDetail" align-h="center" style="height:calc(100vh - 66px);overflow-y:auto;overflow-x:hidden;">
          <b-col>
            <b-row class="mt-3" style="border-bottom: 1px solid #D9D9D9;">
              <b-col class="mb-3">Andamento</b-col>
            </b-row>
            <div style="padding: 0">
              <b-row class="mt-3 justify-content-center">
                <b-col cols="2" class="lined_horizontal text-center"><div class="ongoing_done_history" :style="{backgroundColor:getPurchaseColor(tempDetail, 1)}"><font-awesome-icon style="font-size:8px;color:#ffffff;" :icon="['far', 'check']"/></div></b-col>
                <b-col cols="2" class="lined_horizontal text-center"><div class="ongoing_done_history" :style="{backgroundColor:getPurchaseColor(tempDetail, 2)}"><font-awesome-icon style="font-size:8px;color:#ffffff;" :icon="['far', 'check']"/></div></b-col>
                <b-col cols="2" class="lined_horizontal text-center"><div class="ongoing_done_history" :style="{backgroundColor:getPurchaseColor(tempDetail, 3)}"><font-awesome-icon style="font-size:8px;color:#ffffff;" :icon="['far', 'check']"/></div></b-col>
                <b-col cols="2" class="lined_horizontal text-center"><div class="ongoing_done_history" :style="{backgroundColor:getPurchaseColor(tempDetail, 4)}"><font-awesome-icon style="font-size:8px;color:#ffffff;" :icon="['far', 'check']"/></div></b-col>
                <b-col cols="2" class="lined_horizontal text-center"><div class="ongoing_done_history" :style="{backgroundColor:getPurchaseColor(tempDetail, 5)}"><font-awesome-icon style="font-size:8px;color:#ffffff;" :icon="['far', 'check']"/></div></b-col>
              </b-row>
              <b-row class="mt-1 justify-content-center">
                <b-col cols="2" style="font-size:8px;" class="text-center">{{getPurchaseStatusName(tempDetail, 1)}}</b-col>
                <b-col cols="2" style="font-size:8px;" class="text-center">{{getPurchaseStatusName(tempDetail, 2)}}</b-col>
                <b-col cols="2" style="font-size:8px;" class="text-center">{{getPurchaseStatusName(tempDetail, 3)}}</b-col>
                <b-col cols="2" style="font-size:8px;" class="text-center">{{getPurchaseStatusName(tempDetail, 4)}}</b-col>
                <b-col cols="2" style="font-size:8px;" class="text-center">{{getPurchaseStatusName(tempDetail, 5)}}</b-col>
              </b-row>
            </div>
            <b-row class="mt-3">
              <b-col style="font-size:12px;">Pedido {{tempDetail.PurchaseNumber}}</b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col style="font-size:12px;">Total Produtos: R$ {{formatPrice(tempDetail.PurchaseValue)}}</b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col style="font-size:12px;">Frete/Serviço: R$ {{formatPrice(tempDetail.DeliveryTax)}}</b-col>
            </b-row>
            <b-row class="mt-3" style="border-bottom: 1px solid #D9D9D9;">
              <b-col class="mb-3">Produtos</b-col>
            </b-row>
            <b-row class="mt-3 product_details_header">
              <b-col cols="2" class="text-center">Qtd.</b-col>
              <b-col >Nome</b-col>
              <b-col cols="4" class="text-right">Preço Unitário</b-col>
            </b-row>
            <b-row class="product_details mt-2 justify-content-center align-items-center" v-for="(p, idxp) in tempDetail.ProductList" v-bind:key="idxp" >
              <b-col cols="2" class="text-center">{{p.purchased_quantity}} x</b-col>
              <b-col>{{p.name.toLowerCase()}}</b-col>
              <b-col cols="4" class="text-right" v-if="p.product_views[0].real_price">R$ {{formatPrice(p.product_views[0].real_price)}}</b-col>
              <b-col cols="4" class="text-right" v-else-if="p.product_views[0].promotional_price">R$ {{formatPrice(p.product_views[0].promotional_price)}}</b-col>
              <b-col cols="4" class="text-right" v-else>R$ {{formatPrice(p.product_views[0].price)}}</b-col>
              <b-col class="pb-2" cols="11" style="border-bottom: 1px solid #D9D9D9;"></b-col>
            </b-row>
          </b-col> 
        </b-row>
      </OpaSlideModal>

    </b-container>
    <!-- footer -->
    <b-container fluid>
      <b-row>
        <Footer />
      </b-row>
    </b-container>
  </div>
</template>

<script>
import InnerLoading from '@/components/InnerLoading'
import colors from '@/mixins/colors'
import formaters from '@/mixins/formaters'
import HeaderBackMobile from '@/components/HeaderBackMobile.vue'
import StoreHeader from '@/components/StoreHeader.vue'
import Footer from '@/components/Footer.vue'
import TransactionConn from '@/connection/transactions'
import UserConn from '@/connection/user'
import OpaSlideModal from '@/components/OpaSlideModal'
import MembershipConn from '@/connection/membership'
import graphics from '@/mixins/graphics'

export default {
  data () {
    return {
      loading: true,
      transactions: [],
      timeoutsPurchase: [],
      log: {},
      detailModal:false,
      tempDetail: null,
    }
  },

  mixins: [colors, formaters, graphics],

  components: {InnerLoading, HeaderBackMobile, StoreHeader, Footer, OpaSlideModal},

  async created () {
    if (UserConn.isLoggedIn()) {
      await this.getTransactions()
      await this.getTransactionLog()
      this.loading = false
    } else {
      this.$store.state.registerLoginOrigin = 'history'
      this.$router.push({path: '/login'})
    }
  },

  destroyed () {
    for (var i=0; i<this.timeoutsPurchase.length; i++) {
      clearTimeout(this.timeoutsPurchase[i]);
    }
  },

  methods: {

    async getTransactionLog () { 
      let result = await MembershipConn.getTransactionLog()
      if (!result.error) {
        this.log = result
      } 
      this.loading = false
    },

    async getTransactions () {
      console.log('getTransactions')
      this.transactions = await TransactionConn.getAll()
      this.timeoutsPurchase.push(setTimeout(async () => { await this.getTransactions()}, 30000))
    },

    openDetails (t) {
      this.tempDetail = t
      this.detailModal = true
    },

    getPurchaseStatusName (transaction, index){
      let status = transaction.Status
      // cancelados todos status
      if (status === 7 || status === 8 || status === 10) {
        if (index === 1) {
          return 'Cancelado'
        } else {
          return '--'
        }
      }
      if (index === 1) {
        return 'Realizado'
      }
      if (index === 2 && status === 3) {
        return 'Pagamento Rejeitado'
      } else if (index === 2 && status !== 3 && status !== 12) {
        return 'Pagamento Confirmado'
      } else if (index === 2) {
        return 'Processando Pagamento'
      }
      if (index === 3) {
        return 'Em Preparo'
      }
      if (index === 4 && status === 9) {
        return 'Aguardando retirada'
      } else if (index === 4 && status !== 11) {
        return 'Em Transporte'
      } else if (index === 4 && status === 11) {
        return 'Aguardando Transporte'
      }
      if (index === 5) {
        return 'Entregue'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.transactions_title {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 17px;
  line-height: 20px;
  letter-spacing: 0.15px;
  color: #171D33;
}

.myPointsCard2 {
  width: calc(100% - 16px);
  margin: 0 auto;
  border-radius:6px;
  background-color:#ffffff;
  box-shadow: 0px 4px 20px rgba(18, 28, 42, 0.08);
  cursor: pointer;
}

.history_price {
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.2px;
  color: #525962;
}

.company_title {
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.24px;
  color: #121C2A;
}

.status_box {
  font-size:10px;
  min-height:38px;
  margin:2px 8px 2px 2px!important;
  text-align: center;
  padding:4px;
  align-items: center;
  justify-content: center;
  display: flex;
  border-radius:4px;
  box-shadow: 0px 2px 4px rgba(18, 28, 42, 0.08);
}

.ongoing_done_history {
  width: 18px;
  height:18px;
  border-radius:9px;
  text-align:center;
  line-height:14px;
  margin: 0 auto;
}

.lined_horizontal {
  background: linear-gradient(180deg, 
        rgba(0,0,0,0) calc(50% - 1px), 
        rgba(192,192,192,1) calc(50%), 
        rgba(0,0,0,0) calc(50% + 1px)
    );
}

.product_details {
  font-size:12px;
}

.product_details_header {
  font-size:12px;
  font-weight:500;
}
</style>
